















import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { FiltroEmail, EmailService } from "@/services/email.service";

interface Filtro {
  key: FiltroEmail | number | null;
  text: string;
}

export interface ResultEvent {
  exibirQueryEditor: boolean;
  results?: Promise<number>;
}

class CustomResultEvent implements ResultEvent {
  exibirQueryEditor: boolean;
  results?: Promise<number> | undefined;

  constructor(exibir: boolean, results?: Promise<number>) {
    this.exibirQueryEditor = exibir;
    this.results = results;
  }
}

const filtros: Filtro[] = [
  { key: 0, text: "Editar query" },
  { key: FiltroEmail.Todos, text: "Todos" },
  { key: FiltroEmail.ComPlanoAtivo, text: "Com plano ativo" },
  { key: FiltroEmail.ComPlanoAtivoGratis, text: "Com plano ativo grátis" },
  { key: FiltroEmail.ComPlanoAtivoLite, text: "Com plano ativo lite" },
  { key: FiltroEmail.ComPlanoAtivoEssencial, text: "Com plano ativo essencial" },
  { key: FiltroEmail.ComPlanoAtivoEssencialConectada, text: "Com plano ativo essencial conectada" },
  { key: FiltroEmail.ComPlanoAtivoSuperConectada, text: "Com plano ativo super conectada" },
  { key: FiltroEmail.ComPlanoAtivoHiperConectada, text: "Com plano ativo hiper conectada" },
  { key: FiltroEmail.SemPlanoAtivo, text: "Sem plano" },
];

@Component({})
export default class ComboFiltroEmail extends Vue {
  //Props
  @Prop({ default: "Consultores" }) readonly label!: string;
  @Prop({ default: undefined }) readonly value!: FiltroEmail | number | null;

  //Atributos
  get filtros() {
    return filtros;
  }
  lastValue: FiltroEmail | number | null = null;

  //Metodos
  mounted() {
    this.lastValue = this.value;
    // != null pra cobrir o 0 ("Editar query"), que é falsy mas é seleção válida.
    if (this.lastValue != null) {
      this.onChange(this.lastValue);
    }
  }

  @Watch("value")
  async onChange(val: FiltroEmail | number | null) {
    this.$emit("input", (this.lastValue = val));
    if (val ?? 0 > 0)
      this.$emit(
        "results",
        new CustomResultEvent(
          false,
          EmailService.obterQuantidadeConsultor(val ?? 1)
        )
      );
    else this.$emit("results", new CustomResultEvent(true));
  }
}
